var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, IconButton, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MODOS, MENSAGENS, getDataFormatada, validarData, verificarDatas, parseDate } from '../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../routes';
import { useAuth } from '../../../../contexts/auth/AuthContext';
import { BoxBotoes } from '../../../../components/form_box';
import Loading from '../../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { getInstituicaoTermosContratos, cadastrarInstituicaoTermoContrato, alterarInstituicaoTermoContrato, excluirInstituicaoTermoContrato, getInstituicoesTiposContratosAtivos, getInstituicaoDados, } from '../../../../api';
import { BotaoFechar, BotaoAuxiliar } from '../../../../components/botoes';
import { InputDados } from '../../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import GridComp from '../../../../components/grid';
var InstituicoesTermosContratos = function (props) {
    var MENSAGEM_TERMO_CONTRATO_DUPLICADO = 'Número de contrato ou termo/ano já existe.';
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.CC_INSTITUICOES_TERMOS); }, [getAcoesFuncionalidade]);
    var navigate = useNavigate();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useParams(), id = _b.id, modo = _b.modo;
    var _c = useState({}), TermosContratos = _c[0], setTermosContratos = _c[1];
    var _d = useState([]), TiposContratosDisponiveis = _d[0], setTiposContratosDisponiveis = _d[1];
    var _e = useState(-1), TipoContratoSelecionado = _e[0], setTipoContratoSelecionado = _e[1];
    var _f = useState(''), NumeroTermoContrato = _f[0], setNumeroTermoContrato = _f[1];
    var _g = useState(''), RazaoSocial = _g[0], setRazaoSocial = _g[1];
    var _h = useState(''), DataInicio = _h[0], setDataInicio = _h[1];
    var _j = useState(''), DataFim = _j[0], setDataFim = _j[1];
    var _k = useState(''), TaxaAdministrativa = _k[0], setTaxaAdministrativa = _k[1];
    var _l = useState('Ativo'), Situacao = _l[0], setSituacao = _l[1];
    var _m = useState(false), PopupAberto = _m[0], setPopupAberto = _m[1];
    var _o = useState(), EditarID = _o[0], setEditarID = _o[1];
    var _p = useState(-1), EditarTipoContratoSelecionado = _p[0], setEditarTipoContratoSelecionado = _p[1];
    var _q = useState(''), EditarNumeroTermoContrato = _q[0], setEditarNumeroTermoContrato = _q[1];
    var _r = useState(''), EditarDataInicio = _r[0], setEditarDataInicio = _r[1];
    var _s = useState(''), EditarDataFim = _s[0], setEditarDataFim = _s[1];
    var _t = useState(''), EditarSituacao = _t[0], setEditarSituacao = _t[1];
    var _u = useState(''), EditarTaxaAdministrativa = _u[0], setEditarTaxaAdministrativa = _u[1];
    var setAbaAtiva = props.setAbaAtiva, fluxoCadastro = props.fluxoCadastro;
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var TiposContratosDisponiveis, _a, TermosContratosAux, InstituicaoDadosAux;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, getInstituicoesTiposContratosAtivos()];
                case 1:
                    TiposContratosDisponiveis = _d.sent();
                    setTiposContratosDisponiveis(TiposContratosDisponiveis);
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all([getInstituicaoTermosContratos(id), getInstituicaoDados(id)])];
                case 2:
                    _a = _d.sent(), TermosContratosAux = _a[0], InstituicaoDadosAux = _a[1];
                    setTermosContratos((_b = TermosContratosAux === null || TermosContratosAux === void 0 ? void 0 : TermosContratosAux.termos_contratos) !== null && _b !== void 0 ? _b : []);
                    setRazaoSocial((_c = InstituicaoDadosAux === null || InstituicaoDadosAux === void 0 ? void 0 : InstituicaoDadosAux.razao_social) !== null && _c !== void 0 ? _c : '');
                    return [3 /*break*/, 4];
                case 3:
                    alert('Instituição não enviada');
                    _d.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        var NumeroTermoContratoNormalizado = normalizarNumeroTermoContrato(NumeroTermoContrato);
        if (!TipoContratoSelecionado || TipoContratoSelecionado == -1) {
            alert("Tipo de Contrato ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!NumeroTermoContratoNormalizado) {
            alert("N\u00FAmero do Termo ou Contrato ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!/^\d+$/.test(NumeroTermoContratoNormalizado)) {
            alert("N\u00FAmero do Termo ou Contrato ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        var ArquivoExistente = TermosContratos.some(function (Item) { return Item.numero_termo_contrato == NumeroTermoContratoNormalizado; });
        if (ArquivoExistente) {
            alert(MENSAGEM_TERMO_CONTRATO_DUPLICADO);
            return false;
        }
        if (!RazaoSocial || RazaoSocial.trim() == '') {
            alert("Raz\u00E3o Social ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!DataInicio || DataInicio.trim() == '') {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(DataInicio)) {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        if (!DataFim || DataFim.trim() == '') {
            alert("Data de Encerramento ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(DataFim)) {
            alert("Data de Encerramento ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        if (!verificarDatas(DataInicio, DataFim)) {
            alert('Data de Encerramento deve ser maior que a Data de Início');
            return false;
        }
        return true;
    };
    var validarDadosEditar = function () {
        var EditarNumeroTermoContratoNormalizado = normalizarNumeroTermoContrato(EditarNumeroTermoContrato);
        if (!EditarTipoContratoSelecionado || EditarTipoContratoSelecionado == -1) {
            alert("Tipo de Contrato ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarNumeroTermoContratoNormalizado) {
            alert("N\u00FAmero do Termo ou Contrato ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!/^\d+$/.test(EditarNumeroTermoContratoNormalizado)) {
            alert("N\u00FAmero do Termo ou Contrato ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        var TipoContratoMesmoNome = TermosContratos.filter(function (Item) { return Item.numero_termo_contrato == EditarNumeroTermoContratoNormalizado && Item.id != EditarID; });
        if ((TipoContratoMesmoNome === null || TipoContratoMesmoNome === void 0 ? void 0 : TipoContratoMesmoNome.length) > 0) {
            alert(MENSAGEM_TERMO_CONTRATO_DUPLICADO);
            return false;
        }
        if (!RazaoSocial || RazaoSocial.trim() == '') {
            alert("Raz\u00E3o Social ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarDataInicio || EditarDataInicio.trim() == '') {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(EditarDataInicio)) {
            alert("Data de In\u00EDcio ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        if (!EditarDataFim || EditarDataFim.trim() == '') {
            alert("Data de Encerramento ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(EditarDataFim)) {
            alert("Data de Encerramento ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        if (!verificarDatas(EditarDataInicio, EditarDataFim)) {
            alert('Data de Encerramento deve ser maior que a Data de Início');
            return false;
        }
        return true;
    };
    var adicionarTermoContrato = function () { return __awaiter(void 0, void 0, void 0, function () {
        var NumeroTermoContratoNormalizado, Dados, Resp, termos_contratos;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDados() || !TipoContratoSelecionado)
                        return [2 /*return*/];
                    setLoading(true);
                    NumeroTermoContratoNormalizado = normalizarNumeroTermoContrato(NumeroTermoContrato);
                    Dados = {
                        numero_termo_contrato: NumeroTermoContratoNormalizado,
                        razao_social: RazaoSocial,
                        data_inicio: DataInicio ? parseDate(DataInicio) : null,
                        data_fim: DataFim ? parseDate(DataFim) : null,
                        situacao: Situacao,
                        tipo_contrato_id: TipoContratoSelecionado,
                        taxa_administrativa: TaxaAdministrativa,
                    };
                    return [4 /*yield*/, cadastrarInstituicaoTermoContrato(Dados, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _a.sent();
                    //console.log('Resp', JSON.stringify(Resp));
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        termos_contratos = Resp.dados.termos_contratos;
                        setTermosContratos(termos_contratos !== null && termos_contratos !== void 0 ? termos_contratos : []);
                        limparSelecao();
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarTermoContrato = function () { return __awaiter(void 0, void 0, void 0, function () {
        var EditarNumeroTermoContratoNormalizado, Dados, Resp, TermosContratosAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditar() || !EditarTipoContratoSelecionado)
                        return [2 /*return*/];
                    setLoading(true);
                    EditarNumeroTermoContratoNormalizado = normalizarNumeroTermoContrato(EditarNumeroTermoContrato);
                    Dados = {
                        numero_termo_contrato: EditarNumeroTermoContratoNormalizado,
                        razao_social: RazaoSocial,
                        data_inicio: EditarDataInicio ? parseDate(EditarDataInicio) : null,
                        data_fim: EditarDataFim ? parseDate(EditarDataFim) : null,
                        situacao: EditarSituacao,
                        tipo_contrato_id: EditarTipoContratoSelecionado,
                        taxa_administrativa: EditarTaxaAdministrativa,
                    };
                    return [4 /*yield*/, alterarInstituicaoTermoContrato(Dados, EditarID ? EditarID.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    //console.log('Resp', JSON.stringify(Resp));
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        TermosContratosAtualizados = TermosContratos.map(function (Item) {
                            if (Item.id == EditarID) {
                                return __assign(__assign({}, Item), { numero_termo_contrato: EditarNumeroTermoContratoNormalizado, razao_social: RazaoSocial, data_inicio: EditarDataInicio, data_fim: EditarDataFim, situacao: EditarSituacao, tipo_contrato_id: EditarTipoContratoSelecionado, taxa_administrativa: EditarTaxaAdministrativa });
                            }
                            return Item;
                        });
                        setTermosContratos(TermosContratosAtualizados);
                        setPopupAberto(false);
                        limparPopup();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, TermosContratosAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirInstituicaoTermoContrato(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        TermosContratosAtualizados = TermosContratos.filter(function (Item) { return Item.id != +id; });
                        setTermosContratos(TermosContratosAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecao = function () {
        setTipoContratoSelecionado(-1);
        setNumeroTermoContrato('');
        setDataInicio('');
        setDataFim('');
        setSituacao('Ativo');
        setTaxaAdministrativa('');
    };
    var limparPopup = function () {
        setEditarID(undefined);
        setEditarTipoContratoSelecionado(-1);
        setEditarNumeroTermoContrato('');
        setEditarDataInicio('');
        setEditarDataFim('');
        setEditarSituacao('Ativo');
        setEditarTaxaAdministrativa('');
    };
    var COLUNAS_TERMOS = [
        {
            field: 'numero_termo_contrato',
            headerName: 'Nº Termo / Contrato',
            width: 150,
        },
        {
            field: 'razao_social',
            headerName: 'Razão Social',
            width: 300,
        },
        {
            field: 'tipo_contrato_id',
            headerName: 'Tipo de Contrato',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = TiposContratosDisponiveis.find(function (Item) { return Item.id == row.tipo_contrato_id; })) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'data_inicio',
            headerName: 'Data de Inicio',
            width: 120,
            valueGetter: function (_value, row) { return getDataFormatada(row.data_inicio); },
        },
        {
            field: 'data_fim',
            headerName: 'Data de Fim',
            width: 120,
            valueGetter: function (_value, row) { return getDataFormatada(row.data_fim); },
        },
        {
            field: 'taxa_administrativa',
            headerName: 'Taxa Administrativa (%)',
            width: 180,
        },
        {
            field: 'situacao',
            headerName: 'Situação',
            width: 150,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                abrirPopup(params.row.id);
                            }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return handleDelete(params.row.id); }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var changeNumeroTermoContrato = function (value, func) {
        func(normalizarNumeroTermoContrato(value));
    };
    var normalizarNumeroTermoContrato = function (value) { return value.replace(/\D/g, ''); };
    var changeTaxaADM = function (value, func) {
        // Regex para aceitar números com no máximo um ponto ou uma vírgula
        var regex = /^[0-9]+([.][0-9]*)?$/;
        if ((regex.test(value) && value.length <= 6) || value == '') {
            func(value);
        }
    };
    var abrirPopup = function (TermoContratoID) {
        var Termo = TermosContratos.find(function (Item) { return Item.id == +TermoContratoID; });
        if (Termo) {
            setEditarID(Termo.id);
            setEditarTipoContratoSelecionado(Termo.tipo_contrato_id);
            setEditarNumeroTermoContrato(Termo.numero_termo_contrato);
            setEditarDataInicio(getDataFormatada(Termo.data_inicio));
            setEditarDataFim(getDataFormatada(Termo.data_fim));
            setEditarSituacao(Termo.situacao);
            setEditarTaxaAdministrativa(Termo.taxa_administrativa);
        }
        setPopupAberto(true);
    };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAberto(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ mt: 5 }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'numero-termo-contrato', label: 'N\u00BA do Termo ou Contrato / Ano', value: NumeroTermoContrato, onChange: function (event) { return changeNumeroTermoContrato(event.target.value, setNumeroTermoContrato); }, inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'razao-social', label: 'Raz\u00E3o Social', value: RazaoSocial, disabled: true, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: TipoContratoSelecionado && (_jsxs(InputDados, __assign({ select: true, id: 'tipo-contrato', label: 'Tipo de Contrato', placeholder: 'Tipo de Contrato', value: TipoContratoSelecionado, onChange: function (event) {
                                        setTipoContratoSelecionado(event.target.value);
                                    }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposContratosDisponiveis === null || TiposContratosDisponiveis === void 0 ? void 0 : TiposContratosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] }))) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'data-inicio', label: 'Data de In\u00EDcio', value: DataInicio, mask: '99/99/9999', onChange: function (event) { return setDataInicio(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'data-fim', label: 'Data de Encerramento', value: DataFim, mask: '99/99/9999', onChange: function (event) { return setDataFim(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'taxa-administrativa', label: 'Taxa Administrativa (%)', value: TaxaAdministrativa, 
                                    // mask='999999'
                                    onChange: function (event) { return changeTaxaADM(event.target.value, setTaxaAdministrativa); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'situacao', label: 'Situa\u00E7\u00E3o', placeholder: 'Situa\u00E7\u00E3o', value: Situacao, onChange: function (event) {
                                        setSituacao(event.target.value);
                                    }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarTermoContrato, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: TermosContratos, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(1); } }, { children: "Voltar" })), fluxoCadastro ? (_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'principal.main', onClick: function () { return navigate(ROUTES.CC_INSTITUICOES); } }, { children: "Finalizar" }))) : (_jsx(BotaoFechar, { modo: modo, pagina: ROUTES.CC_INSTITUICOES }))] }))] })), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Termo ou Contrato" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarID, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-numero-termo-contrato', label: 'N\u00BA do Termo ou Contrato / Ano', value: EditarNumeroTermoContrato, onChange: function (event) { return changeNumeroTermoContrato(event.target.value, setEditarNumeroTermoContrato); }, inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-razao-social', label: 'Raz\u00E3o Social', value: RazaoSocial, disabled: true, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: EditarTipoContratoSelecionado && (_jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-contrato', label: 'Tipo de Contrato', placeholder: 'Tipo de Contrato', value: EditarTipoContratoSelecionado, onChange: function (event) {
                                        setEditarTipoContratoSelecionado(event.target.value);
                                    }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposContratosDisponiveis === null || TiposContratosDisponiveis === void 0 ? void 0 : TiposContratosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] }))) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-data-inicio', label: 'Data de In\u00EDcio', value: EditarDataInicio, mask: '99/99/9999', onChange: function (event) { return setEditarDataInicio(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-data-fim', label: 'Data de Fim', value: EditarDataFim, mask: '99/99/9999', onChange: function (event) { return setEditarDataFim(event.target.value); }, disabled: DESABILITAR_CAMPOS, required: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'taxa-administrativa', label: 'Taxa Administrativa (%)', value: EditarTaxaAdministrativa, 
                                    // mask='999999'
                                    onChange: function (event) { return changeTaxaADM(event.target.value, setEditarTaxaAdministrativa); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-situacao', label: 'Situa\u00E7\u00E3o', placeholder: 'Situa\u00E7\u00E3o', value: EditarSituacao, onChange: function (event) {
                                        setEditarSituacao(event.target.value);
                                    }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarTermoContrato, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] }));
};
export default InstituicoesTermosContratos;
